import React, { useState, useEffect, useRef } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
import { useTranslation } from "react-i18next"
import { useSelector, useDispatch } from "react-redux"
import LinearIndeterminate from "../../components/Common/LinearIndeterminate"

import { initLoadTypesMonitor } from "../../store/actions"
import SessionConfig from "../../config/session_config"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import configApp from "../../config/dictionary"

const PagesFaqs = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const ref = useRef()

  //meta title
  document.title = t("pagesFaqs:title") + " | " + t("global:title")

  const [activeTab, setactiveTab] = useState({
    id: "1",
    text: t("pagesFaqs:generalQuestion"),
    code: configApp.configApp.concept.generalQuestion,
  })
  useEffect(() => {
    dispatch(initLoadTypesMonitor(activeTab.code))
  }, [activeTab])
  useEffect(() => {
    document.getElementById("body").className = "fondo5"
  }, [])
  const { error, loading, types } = useSelector(state => {
    return {
      error: state.TypeMonitor.error,
      loading: state.TypeMonitor.loading,
      types: state.TypeMonitor.types,
    }
  })

  const items = () => {
    types.shift()
    return types.map((type, index) => (
      <div className="faq-box d-flex mb-4" key={index}>
        <div className="flex-shrink-0 me-3 faq-icon">
          <i className="bx bx-help-circle font-size-20 text-success" />
        </div>
        <div className="flex-grow-1">
          <h5 className="font-size-15">{type.name}</h5>
          <p className="text-muted">{type.text}</p>
        </div>
      </div>
    ))
  }

  return (
    <React.Fragment>
      <SessionConfig ref={ref} />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={t("global:title")}
            breadcrumbItem={t("pagesFaqs:title")}
          />
          <div className="checkout-tabs">
            <Row>
              <Col lg="2">
                <Nav className="flex-column" pills>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab.id === "1" })}
                      onClick={() => {
                        setactiveTab({
                          id: "1",
                          text: t("pagesFaqs:generalQuestion"),
                          code: configApp.configApp.concept.generalQuestion,
                        })
                      }}
                    >
                      <i className="bx bx-question-mark d-block check-nav-icon mt-4 mb-2" />
                      <p className="font-weight-bold mb-4">
                        {t("pagesFaqs:generalQuestion")}
                      </p>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab.id === "2" })}
                      onClick={() => {
                        setactiveTab({
                          id: "2",
                          text: t("pagesFaqs:privacyPolicy"),
                          code: configApp.configApp.concept.privacyPolicy,
                        })
                      }}
                    >
                      <i className="bx bx-check-shield d-block check-nav-icon mt-4 mb-2" />
                      <p className="font-weight-bold mb-4">
                        {t("pagesFaqs:privacyPolicy")}
                      </p>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab.id === "3" })}
                      onClick={() => {
                        setactiveTab({
                          id: "3",
                          text: t("pagesFaqs:support"),
                          code: configApp.configApp.concept.support,
                        })
                      }}
                    >
                      <i className="bx bx-support d-block check-nav-icon mt-4 mb-2" />
                      <p className="font-weight-bold mb-4">
                        {t("pagesFaqs:support")}
                      </p>
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
              <Col lg="10">
                {loading ? (
                  <LinearIndeterminate></LinearIndeterminate>
                ) : (
                  <Card>
                    <CardBody>
                      <TabContent activeTab={activeTab.id}>
                        <TabPane tabId={activeTab.id}>
                          <CardTitle className="mb-5">
                            {activeTab.text}
                          </CardTitle>
                          {types ? items() : null}
                        </TabPane>
                      </TabContent>
                    </CardBody>
                  </Card>
                )}
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PagesFaqs
